import React, { Component } from "react";
import { Button, Form, Icon, Grid, Card, Table } from "tabler-react";
import Select from "react-select";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
var user = JSON.parse(sessionStorage.getItem("usuario"));
var perfil = JSON.parse(sessionStorage.getItem("perfil"));

class NavieraServiceFailure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenModals: false,
      serviceFailure: { value: 0, label: "Seleccione una opción" },
      accion: this.props.accion,
      corredores: [],
      comentario: "",
      nota: "",
      crudbutonEnable: true,
      listadoServiceFailures: [],
    };
    this.enableSave = this.enableSave.bind(this);
    this.serviceFailureL = [];
    this.movServiceFailureObj = {
      "idMovimiento": this.props.elementos.id,
      "idServiceFailure": null,
      "comentario": "",
      "fecha": "0000-00-00 00:00:00",
      "id_usuario": user.persona
    };
  }

  hiddenmodal = () => { this.setState({ hiddenModals: !this.state.hiddenModals }); }

  getfuntion = (metodo = "get", obj = [], id = "", catalogo = "cliente", stateVar = "clientes", hiddenModl = "") => {
    Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
      switch (metodo) {
        case "get":
          if (stateVar === "corredores") {
            this.corredores = [];
            returnVal.map((corredor, index) => this.corredores.push({ value: corredor.id, label: corredor.nombre, data: corredor }));
            this.setState({ corredores: this.corredores });
            if (this.props.accion === 'nuevo') { this.setState({ idCorredor: { value: 0, label: "Selecciona un corredor" } }); }
          }
          if (stateVar === "list_service_failure" && returnVal) {
            this.setState({ listadoServiceFailures: Array.isArray(returnVal) ? returnVal : [returnVal] });
          }
          break;
        case "post":
          break;
        case "put":
          break;
        default:
          break;
      }
    }).catch(err => {
      if (err.response) { console.log(err.response); } else { console.log("Error desconocido ...."); }
    });
  }

  componentWillMount = () => {
    this.cargaServiceFailures();
  }

  cargaServiceFailures = () => {
    Crud_Catalogos("service_failure/perfil/" + perfil.id, "", "get", "", [], "", "", "", [], "", "", "")
      .then((returnVal) => {
        this.serviceFailureL = [{ value: 0, label: "Seleccione una opción" }];
        if (returnVal) {
          returnVal.map((elemento) => {
            this.serviceFailureL.push({ value: elemento.id, label: elemento.nombre, data: elemento });
            return elemento;
          });
        }
        this.forceUpdate();
      })
      .catch((err) => {
        console.log("Error al cargar service failures:", err);
      });
  }

  componentDidMount = () => {
    this.getfuntion(
      "get",
      "",
      "",
      "navieraMovimientos_service_failure/movimiento/" + this.props.elementos.id,
      "list_service_failure"
    );
  }

  enableSave = () => {
    if (this.state.serviceFailure.value > 0) {
      return false;
    } else { return true }
  }

  changeFailure = (event) => {
    this.setState({ serviceFailure: event });
    this.movServiceFailureObj.idServiceFailure = event.value;
    const encontrado = this.state.listadoServiceFailures.find(lsf => lsf.idServiceFailure === event.value);
    if (encontrado) {
      this.setState({ nota: encontrado.comentario });
      this.movServiceFailureObj.comentario = encontrado.comentario;
    } else {
      this.setState({ nota: "" });
      this.movServiceFailureObj.comentario = "";
    }
  }
  changeNota = (event) => { if (event.target.value.length <= 200) { this.setState({ nota: event.target.value }); this.movServiceFailureObj.comentario = event.target.value; } }

  crud_post() {
    this.props.getfuntion("post", this.movServiceFailureObj, "", "navieraMovimientos_service_failure", "serviceFailure");
    this.setState({ crudbutonEnable: false });
    setTimeout(() => {
      this.getfuntion(
        "get",
        "",
        "",
        "navieraMovimientos_service_failure/movimiento/" + this.props.elementos.id,
        "list_service_failure"
      );
    }, 1000);
  };

  serviceFailureNombre = (idServiceFailure) => {
    for (let sf of this.serviceFailureL) {
      if (sf.value === idServiceFailure) {
        return sf.label;
      }
    }
    return "";
  }

  render() {
    return (
      <div>
        {this.state.accion === "modificar" ? <h1>{this.props.elementos.nombre}</h1> : null}

        <Card>
          <Card.Header>
            <Card.Title><h3 className="text-dark">Información del Movimiento</h3></Card.Title>
          </Card.Header>
          <Card.Body>
            <Grid.Row>
              <Grid.Col md={6}>
                <div style={{ marginBottom: "8px" }}><strong>Corredor: </strong>{this.props.elementos.idCorredor ? this.props.elementos.idCorredor.nombre : ""}</div>
                <div style={{ marginBottom: "8px" }}><strong>Movimiento ID: </strong>{this.props.elementos.id ? this.props.elementos.id : ""}</div>
                <div style={{ marginBottom: "8px" }}><strong>Movimiento Tipo: </strong>{this.props.elementos.idMovimientoTipo ? this.props.elementos.idMovimientoTipo.nombre : ""}</div>
                <div style={{ marginBottom: "8px" }}><strong>Booking: </strong>{this.props.elementos.booking ? this.props.elementos.booking : ""}</div>
              </Grid.Col>
              <Grid.Col md={6}>
                <div style={{ marginBottom: "8px" }}><strong>PO: </strong>{this.props.elementos.po ? this.props.elementos.po : ""}</div>
                <div style={{ marginBottom: "8px" }}><strong>Operación: </strong>{this.props.elementos.idOperacionTipo ? this.props.elementos.idOperacionTipo.nombre : ""}</div>
                <div style={{ marginBottom: "8px" }}><strong>Contenedor: </strong>{this.props.elementos.contenedor ? this.props.elementos.contenedor : ""}</div>
              </Grid.Col>
            </Grid.Row>
          </Card.Body>
        </Card>

        {this.state.listadoServiceFailures.length > 0 && (
          <Card className="mt-3">
            <Card.Header>
              <Card.Title><h3 className="text-dark">Historial de Service Failures</h3></Card.Title>
            </Card.Header>
            <Card.Body>
              <Table
                cards={true}
                striped={true}
                responsive={true}
                className="table-vcenter"
                headerItems={[
                  { content: "Movimiento" },
                  { content: "Service Failure" },
                  { content: "Comentario" },
                  { content: "Usuario" },
                  { content: "Fecha Registro" },
                ]}
              >
                <Table.Header></Table.Header>
                <Table.Body>
                  {this.state.listadoServiceFailures.map((lsf, index) => (
                    <Table.Row key={index} align="center">
                      <Table.Col>{lsf.idMovimiento}</Table.Col>
                      <Table.Col>{this.serviceFailureNombre(lsf.idServiceFailure)}</Table.Col>
                      <Table.Col>{lsf.comentario}</Table.Col>
                      <Table.Col>
                        {lsf.id_usuario
                          ? lsf.id_usuario.nombre + " " + lsf.id_usuario.aPaterno + " " + lsf.id_usuario.aMaterno
                          : ""}
                      </Table.Col>
                      <Table.Col>{lsf.fecha}</Table.Col>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Card.Body>
          </Card>
          )
        }

        <Card className="mt-3">
          <Card.Header>
            <Card.Title><h3 className="text-dark">Registrar Service Failure</h3></Card.Title>
          </Card.Header>
          <Card.Body>
            <Grid.Row>
              <Grid.Col md={12}>
                <Form.Group label="Service Failure">
                  <Select value={this.state.serviceFailure} onChange={this.changeFailure} options={this.serviceFailureL} />
                </Form.Group>
                {this.state.serviceFailure && this.state.serviceFailure.data && (
                  <div className="mb-3">
                    <div>
                      <strong>Categoría: </strong>
                      {this.state.serviceFailure.data.categoria
                        ? this.state.serviceFailure.data.categoria.nombre
                        : "Sin categoría"}
                    </div>
                    <div>
                      <strong>Descripción: </strong>
                      {this.state.serviceFailure.data.descripcion || "Sin descripción"}
                    </div>
                  </div>
                )}
                <Form.Group label={<Form.Label aside={this.state.nota.length + "/200"}>Nota</Form.Label>}>
                  <Form.Textarea value={this.state.nota} name="nota" onChange={this.changeNota} placeholder="Comentario.." rows={7} />
                </Form.Group>
              </Grid.Col>
            </Grid.Row>
            <div className="float-right">
              <Button target="_blank" size="sm" RootComponent="a" color="primary" disabled={this.enableSave() || !this.state.crudbutonEnable}
                onClick={() => this.crud_post()}>
                <Icon link={true} name="save" /> Guardar
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default NavieraServiceFailure;
